import { LoadingOverlay } from '@mantine/core';
import App from '@/App';
import '@xyflow/react/dist/style.css';
import type { TAccount } from '@/types/common.ts';

interface FlowBuilderProps {
	clientSecret: string;
	account: TAccount;
}

const FlowBuilder = ({ clientSecret, account }: FlowBuilderProps) => {
	return (
		<div
			className="notranslate"
			style={{ display: 'contents' }}
			translate="no"
		>
			{clientSecret ? (
				<App
					account={account}
					clientSecret={clientSecret}
				/>
			) : undefined}
			<LoadingOverlay
				overlayProps={{ radius: 'sm', blur: 1 }}
				visible={!clientSecret}
				zIndex={1000}
			/>
		</div>
	);
};

export default FlowBuilder;
